export default "__VITE_ASSET__RdAPJ7zz__"